import { getEnvBaseURL } from "../../utils/util";
import {
  ADD_TENANT_INFORMATION,
  UPDATE_TENANT_STATUS,
  ADD_USER_STEPS,
  ADD_WEBHOOKS,
  FETCH_WEBHOOKS,
  REMOVE_WAREHOUSE,
  ADD_ENVIRONMENT,
  UPDATE_COMPLIANCE_FORM_STATUS,
  UPDATE_ENVIRONMENT_BASE_URL,
  UPDATE_CREATOR_LINKAGE_MODULE_STATUS,
  UPDATE_PRODUCTION_KEY_STATUS,
} from "./types";

const DEFAULT_WAREHOUSE_STATE = {
  tenantInfo: [],
  tenantStatus: false,
  webhooks: [],
  environment: {
    current: localStorage.getItem("currentEnv") ? localStorage.getItem("currentEnv") : "production",
    // current: "staging",
    available: ["sandbox", "production", "staging"],
    environmentURLMapping: {
      sandbox: process.env.REACT_APP_SDK_API_ENDPOINT,
      staging: process.env.REACT_APP_SDK_API_STAGING_ENDPOINT,
      production: process.env.REACT_APP_SDK_API_PRODUCTION_ENDPOINT,
    },
  },
  webhookStatus: {
    loading: true,
    error: "",
    fetchedInitially: false,
  },
  userCurrentStep: 1,
  isComplianceFormFilled: false,
  productionKeys: {
    isAvailable: false,
    prodTenantId: "",
    prodClientId: "",
    prodClientSecret: "",
    productionEnabledTenantProducts: [],
  },
  showCreatorLinkageModule: false,
  // environmentBaseURL: localStorage.getItem("currentEnv")
  //   ? getEnvBaseURL(localStorage.getItem("currentEnv"))
  //   : process.env.REACT_APP_SDK_API_STAGING_ENDPOINT,
  environmentBaseURL: localStorage.getItem("currentEnv")
    ? getEnvBaseURL(localStorage.getItem("currentEnv"))
    : process.env.REACT_APP_SDK_API_PRODUCTION_ENDPOINT,
  // environmentBaseURL: process.env.REACT_APP_SDK_API_STAGING_ENDPOINT,
  environmentChanged: false,
};

const warehouseReducer = (state, action) => {
  switch (action.type) {
    case ADD_TENANT_INFORMATION:
      return {
        ...state,
        tenantInfo: action.payload,
        environmentChanged: false,
      };
    case UPDATE_TENANT_STATUS:
      return { ...state, tenantStatus: true };
    case FETCH_WEBHOOKS:
      return { ...state, webhookStatus: { loading: true, error: "" } };
    case ADD_WEBHOOKS:
      return {
        ...state,
        webhooks: action.payload,
        webhookStatus: { loading: false, error: "", fetchedInitially: true },
      };
    case REMOVE_WAREHOUSE:
      return {
        ...state,
        ...DEFAULT_WAREHOUSE_STATE,
      };
    case ADD_USER_STEPS:
      return {
        ...state,
        userCurrentStep: action.payload,
      };
    case ADD_ENVIRONMENT:
      return {
        ...state,
        tenantInfo: [],
        tenantStatus: false,
        webhooks: [],
        webhookStatus: {
          loading: true,
          error: "",
          fetchedInitially: false,
        },
        environment: {
          current: action.payload,
          available: DEFAULT_WAREHOUSE_STATE.environment.available,
          environmentURLMapping: DEFAULT_WAREHOUSE_STATE.environment.environmentURLMapping,
        },
        environmentChanged: true,
      };
    case UPDATE_COMPLIANCE_FORM_STATUS:
      return {
        ...state,
        isComplianceFormFilled: true,
      };
    case UPDATE_PRODUCTION_KEY_STATUS:
      return {
        ...state,
        productionKeys: {
          isAvailable: true,
          prodTenantId: action.payload.prodTenantId,
          prodClientId: action.payload.prodClientId,
          prodClientSecret: action.payload.prodClientSecret,
          prodTenantAppName: action.payload.prodTenantAppName,
          productionEnabledTenantProducts: action.payload.productionEnabledTenantProducts,
        },
      };
    case UPDATE_CREATOR_LINKAGE_MODULE_STATUS:
      return {
        ...state,
        showCreatorLinkageModule: true,
      };
    case UPDATE_ENVIRONMENT_BASE_URL:
      return {
        ...state,
        environmentBaseURL: action.payload,
      };
    // case "ADD_WEBHOOKS":
    //   return {
    //     ...state,
    //     webhooks: action.payload,
    //   };
    default:
      return state;
  }
};

export { DEFAULT_WAREHOUSE_STATE, warehouseReducer };
